import React from 'react';
import { Link } from 'react-router-dom';

/**
 * @param {{ items: Array<{ label: string, to?: string }> }} props
 */
export default function AdminHubBreadcrumbs({ items }) {
  if (!items?.length) return null;
  return (
    <nav className="admin-hub-kit-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`}>
            {i > 0 ? <span className="admin-hub-kit-breadcrumb__sep">/</span> : null}
            {item.to && !isLast ? (
              <Link to={item.to}>{item.label}</Link>
            ) : (
              <span className={isLast ? 'admin-hub-kit-breadcrumb__current' : undefined}>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
